<footer class="footer">
  <br />
  <span class="colorText">SISTEMA RECURSOS HUMANOS GRUPO FIRMA</span>
</footer>
